import { Box, Button, ButtonBase, Paper, Typography } from '@material-ui/core';
import { AccessTime, AttachMoney } from '@material-ui/icons';
import clsx from 'clsx';
import React from 'react';
import { IService } from '../../../../shared/interfaces/service-interfaces';

import useStyles from './style';

type IProps = {
  service: IService;
  selected: boolean;
  handleClick: () => void;
};

const Service: React.FC<IProps> = ({ service, selected, handleClick }) => {
  const classes = useStyles();

  return (
    <ButtonBase
      className={clsx(classes.service, selected && classes.selected)}
      onClick={handleClick}
    >
      <Box width="100%">
        <Typography style={{ fontSize: '1.1em' }}>
          {`${service.service_name}`}
        </Typography>
        <Box display="flex" width="100%">
          <AttachMoney color={selected ? 'primary' : 'inherit'} />
          <Typography style={{ marginRight: '16px' }}>
            {service.price ?? '-'}
          </Typography>
          <AccessTime color={selected ? 'primary' : 'inherit'} />
          <Typography style={{ marginLeft: '4px' }}>
            {`${service.time_box} min`}
          </Typography>
        </Box>
      </Box>
    </ButtonBase>
  );
};

export default Service;
